import React from 'react';
import { History } from 'history';
import { Grid } from '@mui/material';
import { Chip, GridContainer, ProgressBar, ScreenGuard, Text, Webcam } from '../../components';
import Model from './event-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model'
import UserModel from '../user/user-model';
import ReportgroupModel from '../reportgroup/reportgroup-model';
import BaseView from '../base/base-view.component';
import BaseEdit from '../base/base-edit.component';
import EventCreatePublic from './event-create-public.component';
import EventquizCreatePublic from '../eventquiz/eventquiz-create-public.component';
import SectionPicklistCard from '../section/section-picklistcard.component';
import QuizquestionPicklistCard from '../quizquestion/quizquestion-picklistcard.component';
import QuizresultList from '../quizresult/quizresult-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    uid?: string;
    onLoad?: (data: any) => void;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
    datarowEventInfo: Model;
    datarowEdit: any;
    datarowReportgroup: ReportgroupModel;
    sectionHeader: any;
    sectionReplaceText: any;
    pageDirection: number;
    pageLevel: number;
    pageSize: number;
    message: number;
    timeLeft: number;
    timeOffline: number;
    eventquizAnswered: number;
    eventquizTotal: number;
    isError: boolean;
    isOneByOne: boolean;
    isHasQuestion: boolean;
    isRestrictCamera: boolean;
    isCapture: boolean;
    isTimeout: boolean;
    isAppBarHide: boolean;
    readOnly: boolean;
    save: boolean;
    shareReport: boolean;
}

export default class EventViewPublic extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
            datarowEventInfo: Model.defaultValue(),
            datarowEdit: null,
            datarowReportgroup: ReportgroupModel.defaultValue(),
            sectionHeader: null,
            sectionReplaceText: null,
            pageDirection: 0,
            pageLevel: 0,
            pageSize: 0,
            message: -1,
            timeLeft: -1,
            timeOffline: 0,
            eventquizAnswered: 0,
            eventquizTotal: 0,
            isError: false,
            isOneByOne: false,
            isHasQuestion: false,
            isRestrictCamera: false,
            isCapture: false,
            isTimeout: false,
            isAppBarHide: true,
            readOnly: false,
            save: false,
            shareReport: false,
        }
    }

    private historyState: any = this.props.history.location.state;
    private isMobile: boolean = AppService.isMobile();

    private hasId = () => {
        return this.historyState?.id || this.props.uid;
    }
    
    private getPermission = async(data: any) => {
        await this.setState({ isRestrictCamera: data===false })
    }

    private getImage = (data: any) => {
        if (!data.value) return;
        
        const filename = 'event' + this.state.datarow.id + '_' + new Date().getTime() + '.png';
        const file = new File( [data.uint8], filename, { lastModified: new Date().getTime(), type: data.mime,} )
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow: {id: this.state.datarow.imageId, files: file, ref: Model.endPointMedia, field: 'image'}}, isCapture: false, save: true,});
    }

    private getTimeOffline() {
        setTimeout(() => {
            const timeOffline = localStorage.getItem('timeOffline');
            if (!navigator.onLine && !timeOffline) 
                localStorage.setItem('timeOffline', new Date().getTime().toString());
            else if (timeOffline) {
                this.setState({timeOffline: this.state.timeOffline + Math.ceil((new Date().getTime() - +timeOffline) / 1000)});
                localStorage.removeItem('timeOffline');
            }
        }, 6000);
    }

    private getTimeLeft(timeLimit: number) {
        if (timeLimit > 0) {
            this.getTimeOffline();
            const startDate = new Date(this.state.datarow.startdate);
            const timeAdj = (timeLimit + this.state.timeOffline) * 1000;
            const timeLeft = Math.ceil(((new Date(startDate).getTime() + timeAdj) - new Date().getTime()) / 1000);
            navigator.onLine && timeLeft >= 0 && setTimeout(() => this.setState({timeLeft: timeLeft}), 1000);
        }
    }

    private getTimeLimit() {
        if (!this.state.datarow.enddate && this.state.datarow.section0?.timelimit > 0) {
            this.getTimeLeft(this.state.datarow.section0?.timelimit);
            if (this.state.timeLeft === 0) localStorage.setItem('eventEnddate' + this.state.datarow.id, AppService.dateCurrent());
        }
    }    
    
    private getMessage(data?: any, pageLevel?: number) {
        /*
        01. quiz message offline
        02. quiz message invalid
	    03. quiz message error
        04. quiz message notallowcamera
        05. quiz message timeout
        06. quiz message finishquestion
        07. quiz message finishsection
        08. quiz message finishsendresult
        09. quiz message startnotyet
        10. quiz message endextratime
        11. quiz message end
        12. quiz message finish
        99. quiz message start
        */

        const eventParticipant = data?.eventParticipantCurrent;
        const isEventPublic = data?.type?.includes('-public');

        return (
            //all page
            !navigator.onLine? 1
            : !this.hasId() || (!this.state.datarow.id && (!data?.id || !data?.section || !data?.startdate)) || (!eventParticipant && !isEventPublic)? 2
            : this.state.datarow.type.startsWith('meeting-') && this.state.datarow.addressLinkpath? 2
            : this.state.errors? 3

            // 3rd page
            : pageLevel === 3 && this.state.datarow.section0?.timelimit > 0 && localStorage.getItem('eventEnddate' + this.state.datarow.id)? 5
            : pageLevel === 3 && this.state.datarow.section0?.questionLength > 0 && this.state.datarow.eventquizAnswered >= this.state.datarow.section0?.questionLength - this.state.datarow.section0?.questiontolerance? 6
            : pageLevel === 3 && this.state.datarow.section0?.sectionLength > 0 && this.state.datarow.section0?.sectionLength === this.state.datarow.eventEnded? 7

            // 2nd page
            : pageLevel === 2 && !eventParticipant?.enddate && eventParticipant?.eventLength > 0 && eventParticipant?.eventLength === eventParticipant?.eventEnded? 8

            // 1st page
            : pageLevel === 1 && AppService.dateISO(data?.startdate) >= AppService.dateCurrent()? 9
            : pageLevel === 1 && data?.enddate && data?.extratime === 'yes' && !eventParticipant?.enddate && eventParticipant?.extratime === 'no'? 10
            : pageLevel === 1 && data?.enddate? 11
            : pageLevel === 1 && eventParticipant?.enddate? 12
            : pageLevel === 1 && AppService.dateISO(data?.startdate) < AppService.dateCurrent()? 99
            
            : this.state.isRestrictCamera? 4
            : 0
                
        );      
    }

    private onLoad = (data: any) => {
        if (data) {
            if (data.enddate)
                this.props.history.goBack();
            else {
                if (!data.parent) {
                    AppService.historyState('id', data.id);
                    this.historyState = AppService.historyState('eventInfo', 
                        {id: data.id, participant: data.participantCurrent?.id, participantCaption: data.participantCurrent?.name}
                    );
                    this.props.history.location.state = this.historyState;
                }
                this.setState({ datarow: data })
            }
        }
    }
    
    private onLoadEventInfo = (data: any) => {
        if (data) {
            const menu = [
                {caption: data.startenddateFmt, size: 'small', icon: 'today'},
                {caption: data.participantCurrent?.name, size: 'small', icon: 'account_circle'}, 
            ];
            const error = Object.values(this.state.errors || [])?.[0]?.toString() || '';
            const pageLevel = !this.state.datarow.parent? 1 : this.state.datarow.parent === data?.id? 2 : 3;
            const message = this.getMessage(data, pageLevel);
            const pageSize = this.state.datarow.viewstyle?.includes('onebyone') && message !== 7 ? 1 : 20;
            const sectionHeader = [
                {name: 'title', color: 'primary.light'}, 
                {name: 'content', noWrap: message === 0}
            ];
            const isHasQuestion = pageLevel === 3 && this.state.datarow.section0?.questionLength > 0;

            this.props.onLoad?.({appbar: {menu: pageLevel > 1 && menu, onHide: this.onHideAppBar}});
            
            this.setState({
                datarowEventInfo: data,
                sectionHeader: sectionHeader,
                sectionReplaceText: {error: error, participantcaption: data.participantCurrent?.name, eventname: this.state.datarow.name, eventdate: data.startdateFmt},
                pageDirection: [5, 6, 7, 8].includes(message)? -1 : [0, 99].includes(message)? 1 : 0,        
                pageLevel: pageLevel,
                pageSize: pageSize,
                message: message,
                isError: [1, 2, 3, 4, 5].includes(message),
                isOneByOne: pageSize === 1,
                isHasQuestion: isHasQuestion,
                isTimeout: isHasQuestion && message === 5,
                isCapture: isHasQuestion && !this.state.datarow.imageId && !this.state.isCapture? true : this.state.isCapture,
                eventquizAnswered: this.state.datarow.eventquizAnswered,
                timeLeft: this.state.timeLeft === 0? -1 : this.state.timeLeft,
            });

            if (message === 6) document.getElementById('Top')?.scrollIntoView(true);
        }
    }

    private onLoadReportgroup = (data: any) => {
        this.setState({datarowReportgroup:  data});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onSave = (data: any) => {
        if (data.enddate) localStorage.removeItem('eventEnddate' + data?.id);
        this.setState({ datarow: {...this.state.datarow, imageId: data.imageId}, save: false, shareReport: false});
    }

    private onSaveBefore = () => {
        if (this.state.pageDirection < 0) {        
            const enddate = localStorage.getItem('eventEnddate' + this.state.datarow.id);
            this.setState({ datarowEdit: {enddate: enddate || AppService.dateCurrent()} });
        }

        this.setState({ shareReport: this.state.message === 8});
    }

    private onSaveEventquiz = (data: any) => {
        //data.answered = 0: no changes, 1: answered, -1: no answered
        const eventquizAnswered = Math.min(this.state.datarow.section0.questionLength, this.state.datarow.eventquizAnswered + data.answered)
        this.setState({ datarow: {...this.state.datarow, eventquizAnswered: eventquizAnswered} });
    }

    private onHideAppBar = (data: any) => {
        this.setState({ isAppBarHide: data});
    }

    public componentDidUpdate() {
        this.props.history.location.search = '';
        if (!UserModel.isSignin())
            this.props.history.replace({}, AppService.historyState('authSignin', true));
        if ((this.state.datarow.eventquizAnswered && this.state.datarow.eventquizAnswered !== this.state.eventquizAnswered) || (this.state.timeLeft === 0))
            this.onLoadEventInfo(this.state.datarowEventInfo);
        if (!this.hasId() && this.state.message < 0 && this.state.pageLevel <= 0) {
            this.setState({message: this.getMessage(), isError: true});
        }
        
        const isReadOnly = this.state.isCapture || this.state.save || this.state.isTimeout;
        if (this.state.readOnly !== isReadOnly)
            this.setState({readOnly: isReadOnly});
        if (!isReadOnly)
            this.getTimeLimit();
    }

    private displayContent() {
        return (
            <Grid id='TopContent' container alignContent={this.state.pageLevel > 1 ? 'start' : 'center'} minHeight='70vh'>

                {!this.state.isError && this.state.pageLevel > 1 &&
                <Grid item xs={12} md={12} mb={1.5}>
                    <GridContainer>
                        <Text label={this.state.datarowEventInfo.name} color='primary.dark' size='large' bold />
                        {this.state.datarowEventInfo.eventParticipantCurrent?.extratime === 'yes' && 
                        <Chip label='Perpanjangan Waktu' sx={{marginTop: 1}}/> 
                        }
                    </GridContainer>
                </Grid>
                }
                
                {!this.state.isError &&
                <Grid display='flex' position='fixed' right={this.isMobile? 0 : 65} top={this.state.isAppBarHide? 65 - window.scrollY : 0}>
                    {this.state.datarow.section0?.timelimit > 0 && this.state.timeLeft > 0 && this.state.timeLeft < 60 &&
                        <ProgressBar caption='detik' value={Math.max(0, this.state.timeLeft)} totalValue={60} color='#ff5722' bgColor='#ffd6c9'/>
                    }
                    {this.state.isHasQuestion &&
                        <ProgressBar value={this.state.datarow.eventquizAnswered} totalValue={this.state.datarow.section0?.questionLength} hideOnComplete={!this.state.datarow.section0.timelimit || this.state.isHasQuestion}/>
                    }
                </Grid>
                }

                {this.state.message > 0 &&
                <Grid item xs={12} md={this.state.isError || this.state.pageLevel <= 1? 12 : 7}>
                    <SectionPicklistCard history={this.props.history} caption=' ' nodataCaption=' ' tag='quizmessage' seq={this.state.message} pageSize={1} replaceText={this.state.sectionReplaceText} cardDirection='row' disablePagination disableSearch disableCard disableCardChild>
                        {this.state.message === 12?
                            <QuizresultList history={this.props.history} caption=' ' eventName={this.state.datarow.eventParticipantCurrent?.name} actions={[]} disableBackButton />
                        :   <EventCreatePublic history={this.props.history} parentId={this.state.pageDirection < 0 ? this.state.datarow.parent : this.state.datarow.id} sectionId={this.state.message && this.state.datarow.section0?.id} pageDirection={this.state.pageDirection} datarow={this.state.datarowEdit} onSave={this.onSave} onSaveBefore={this.onSaveBefore}/>
                        }
                    </SectionPicklistCard>
                </Grid>
                }
                    
                {!this.state.isError && this.state.pageLevel > 1 && 
                <Grid item xs={12} md={12}>
                    <SectionPicklistCard history={this.props.history} caption=' ' nodataCaption=' ' parentId={this.state.pageLevel === 3 && this.state.datarow.section0?.id} eventId={this.state.datarow.id} header={this.state.sectionHeader} pageSize={this.state.pageSize} replaceText={this.state.sectionReplaceText} disablePagination={this.state.isOneByOne} disablePaginationButtonPage disableSearch disableCard >
                        <EventCreatePublic history={this.props.history} parentId={this.state.datarow.id} pageDirection={this.state.pageDirection} datarow={this.state.datarowEdit} onSave={this.onSave} onSaveBefore={this.onSaveBefore}/>
                    </SectionPicklistCard>
                </Grid>
                }
                
                {!this.state.isError && this.state.isHasQuestion &&
                <Grid item xs={12} md={12}>
                    <QuizquestionPicklistCard history={this.props.history} caption=' ' nodataCaption=' ' sectionId={this.state.datarow.section0?.id} pageSize={this.state.pageSize} paginationAlign='center' disablePagination={this.state.isOneByOne && this.state.datarow.section0?.questionLength === 1} disablePaginationButtonPage disableSearch disableCard disableCardChild={this.state.message === 0 && (this.state.pageSize === 1 || this.state.datarow.section0?.questionLength <= 1)}>
                        <EventquizCreatePublic history={this.props.history} eventId={this.state.datarow.id} onSave={this.onSaveEventquiz} readOnly={this.state.readOnly}/>
                    </QuizquestionPicklistCard>
                </Grid>
                }
                
                {/*this.state.shareReport && this.state.datarowReportgroup.reportLength > 0 &&
                    <EventShare history={this.props.history} id={this.state.datarowEventInfo?.id} buttonCaption='Kirim Hasil' processCaption='Mohon menunggu, hasil sedang dibentuk dan akan dikirim.' participantId={this.state.datarow.participant?.[0]?.id} reportId={this.state.datarowReportgroup.report?.[0]?.id} to={this.state.datarowEventInfo.customerEmail || this.state.datarow.participantCurrent?.email} onSave={this.onSave} disableView/>
                */}
                
            </Grid>
        )
    }

    render() {
        return (
            //editable..
            <ScreenGuard>
                {this.hasId() &&
                <BaseEdit history={this.props.history} caption=' ' buttonCaption=' '
                    endPointFilter={Model.endPointFilter(this.historyState?.id? '' : this.props.uid)} model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} save={this.state.save} onLoad={this.onLoad} onError={this.onError} onSave={this.onSave} disableBackButton disableAutoBack disableCard />
                }
                
                {this.state.datarow.id > 0 && this.historyState?.eventInfo?.id &&
                <BaseView id={this.historyState?.eventInfo?.id} caption=' ' 
                    endPointFilter={Model.endPointFilter()} model={Model} onLoad={this.onLoadEventInfo} cardColor='background.paper' cardGradientColor='white' disableBackButton >
                
                    {this.state.datarow.usecamera === 'yes' && <Webcam hide shotTimeout={this.state.isCapture? 1 : 0} stop={!this.state.isCapture} getImage={this.getImage} getPermission={this.getPermission}/>}                    
                    {(this.state.datarowEventInfo.id || this.state.isError) && this.displayContent()}
                </BaseView>
                }
                
            </ScreenGuard>
        );
    }
}